export default class Footer {
    constructor() {
        this.footer = document.querySelector('footer');
        this.btnScrollToTop = this.footer.querySelector('.scrollToTop')

        this.ready();
    }

    ready() {
        if (this.btnScrollToTop) {
            this.btnScrollToTop.addEventListener('click', () => {
                    window.scrollTo({ top: 0, behavior: 'smooth' });
            }, false);
        }
    }
}